import { deposit_socket_url } from "./apiUtils";
import { createAdminSocket } from "./socketConfig";

const depositSocket = createAdminSocket(deposit_socket_url, {
  autoConnect: false,
});

export default depositSocket;
